import { render, staticRenderFns } from "./videoPop.vue?vue&type=template&id=4dcd90d2&scoped=true&"
import script from "./videoPop.vue?vue&type=script&lang=js&"
export * from "./videoPop.vue?vue&type=script&lang=js&"
import style0 from "./videoPop.vue?vue&type=style&index=0&id=4dcd90d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd90d2",
  null
  
)

export default component.exports